import React from 'react';
import './CancellationReturnPolicy.css';

const CancellationReturnPolicy = () => {
  return (
    <div className="cancellation-page">
      <section className="cancellation-hero">
        <div className="container">
          <h1>Cancellation & Return Policy</h1>
          <p className="last-updated">Last updated: January 22, 2026
          </p>
        </div>
      </section>

      <div className="cancellation-content">
        <section className="cancellation-section">
          <h2>1. Orders Placed by Private Individuals/Consumers</h2>
          <h3>1.1 Right of Withdrawal</h3>
          <p>
            Consumers have the right to withdraw from a distance purchase within <strong>14 calendar days</strong> of receiving the goods.
          </p>

          <p>
            However, <strong>this right does not apply</strong> to:
          </p>
          <ul>
            <li>Sealed food products that are <strong>not suitable for return for health protection or hygiene reasons</strong>, once unsealed after delivery.</li>
            <li>Products that are on <strong>sale or near end of shelf life</strong>.</li>
          </ul>

          <p>
            If the product is sealed and unopened, and the withdrawal request is made within 14 days of delivery, the consumer may be eligible for a refund, subject to inspection.
          </p>

          <h3>2.2 How to Cancel an Order</h3>
          <p>
            To exercise the right of withdrawal (where applicable), the consumer must notify us in writing by email, including:
          </p>
          <ul>
            <li>Order number</li>
            <li>Full name and contact details</li>
            <li>Clear statement of withdrawal</li>
          </ul>

          <p>
            The notification must be sent within 14 days of receiving the goods.
          </p>

          <h3>1.3 Return Conditions</h3>
          <p>
            Returned products must:
          </p>
          <ul>
            <li>Be <strong>unused, unopened, and in their original sealed packaging</strong></li>
            <li>Include all original labels and documentation</li>
            <li>Be returned within <strong>14 days</strong> of notifying us of cancellation</li>
          </ul>
          <p>For food safety reasons, we reserve the right to refuse returns that do not meet these conditions.</p>

          <h3>1.4 Refunds</h3>
          <ul>
            <li>Approved refunds will be issued using the original payment method.</li>
            <li>Refunds will be processed within <strong>14 days</strong> of receiving and inspecting the returned goods.</li>
            <li>Original shipping costs are refundable only where applicable.</li>
            <li>Return shipping costs are borne by the consumer, unless the return is due to an error on our part.</li>
          </ul>
        </section>

        <section className="cancellation-section">
          <h2>2. Order Cancellation</h2>

          <h3>Cancellation Before Dispatch</h3>
          <p>
            If you change your mind about your order <strong>before it has been dispatched</strong>, 
            we are able to accept cancellations at any time and process a full refund of the order amount.
          </p>

          <h3>How to Cancel</h3>
          <ul>
            <li>Contact us as soon as possible via email: <strong><a href="mailto:info@munchups.se">info@munchups.se</a></strong></li>
            <li>Include your order number and request cancellation</li>
            <li>We will confirm cancellation and process your refund</li>
          </ul>

          <h3>Refund Timeline</h3>
          <p>
            Refunds for cancelled orders will be processed within <strong>14 days</strong> of cancellation approval 
            to your original payment method (credit card, Swish, or bank account).
          </p>

          <h3>Cancellation After Dispatch</h3>
          <p>
            Once an order has been dispatched, it cannot be cancelled directly. However, you can still exercise your 
            right of withdrawal (see Section 1).
          </p>
        </section>

        <section className="cancellation-section">
          <h2>3. Damaged, Defective, or Incorrect Products</h2>

          <p>
            For all customers:
          </p>
          <ul>
            <li>Any issues must be reported immediately upon receipt.</li>
            <li>Please provide clear photos of the damaged packaging, product, and shipping label.</li>
            <li>We may offer a replacement, refund, or partial refund depending on the situation.</li>
          </ul>
          <p>Products damaged due to improper storage by the customer after delivery are not eligible for refund.</p>
        </section>

        <section className="cancellation-section">
          <h2>4. Partial Refunds</h2>

          <h3>When Partial Refunds May Apply</h3>
          <p>
            A partial refund may be issued if:
          </p>
          <ul>
            <li>The product is returned with original, intact packaging.</li>
            <li>Order is delivered with missing item or damaged item.</li>
            <li>Order is partially cancelled. This may incur shipping costs.</li>
          </ul>

          <h3>When Partial Refunds Do Not Apply</h3>
          <p>
            Partial refunds will not be granted in the following situations:
          </p>
          <ul>
            <li>Opened or unsealed food product.</li>
            <li>Products that are damaged, spoiled, expired, or contaminated after delivery.</li>
            <li>Returns made after the 14-day statutory return period, where applicable.</li>
            <li>Sale or clearance items are not eligible for refund.</li>
          </ul>
          <h3>Wholesale Orders</h3>
          <p>
            For wholesale (B2B) orders, partial refunds may be further limited or excluded, except where products are defective or incorrect upon delivery.
          </p>
        </section>

        <section className="cancellation-section">
          <h2>5. Contact Information</h2>

          <p>
            For cancellation or refund requests, please contact us at:
          </p>
          <p>Email: <a href="mailto:info.munchups@gmail.com">info.munchups@gmail.com</a></p>
          <p>Please retain your order confirmation and proof of purchase for all correspondence.</p>
        </section>

        <div className="cancellation-footer">
          <p>
            By using our website, you acknowledge that you have read and understood this Terms &amp; Conditions 
            and agree to it.
          </p>
          <p>
            Last updated: January 22, 2026
          </p>
        </div>
      </div>
    </div>
  );
};

export default CancellationReturnPolicy;
